const DropdownIcon = ({ className = '' }: { className?: string }) => (
  <svg
    className={className}
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.1669 5.83337H5.83352C5.53102 5.83337 5.25185 5.99754 5.10435 6.26254C4.95769 6.52754 4.96602 6.85171 5.12685 7.10837L9.29352 13.775C9.44602 14.0184 9.71269 14.1667 10.0002 14.1667C10.2877 14.1667 10.5544 14.0184 10.7069 13.775L14.8735 7.10837C15.0344 6.85171 15.0427 6.52754 14.896 6.26254C14.7485 5.99754 14.4694 5.83337 14.1669 5.83337Z'
      fill='#2A1846'
    />
  </svg>
)

export default DropdownIcon
